import React from 'react';
import { bool, string, shape } from 'prop-types';
import classnames from 'classnames';
import Message from '../message';
import { StyledLabel } from '@vpp-frontend-components/styled-label';

const namespace = 'ui-vip-seller-reputation-banner';

const SellerReputationBanner = ({ className = '', body, type, closeable, hierarchy }) => (
  <Message className={classnames(namespace, className)} type={type} closeable={closeable} hierarchy={hierarchy}>
    <StyledLabel {...body} />
  </Message>
);

SellerReputationBanner.propTypes = {
  className: string,
  closeable: bool.isRequired,
  hierarchy: string.isRequired,
  type: string.isRequired,
  body: shape({
    text: string.isRequired,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
};

export default SellerReputationBanner;
